/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type ActivePeriodsFilterConfigColumn =
  (typeof ActivePeriodsFilterConfigColumn)[keyof typeof ActivePeriodsFilterConfigColumn];

export const ActivePeriodsFilterConfigColumn = {
  active_periods: 'active_periods',
} as const;
